import { I18NextService } from 'angular-i18next';

export const getPeriods = (i18: I18NextService) => [
  { value: 15, label: i18.t('shared:tfa.periods.fifteenMinutes') },
  { value: 30, label: i18.t('shared:tfa.periods.thirtyMinutes') },
  { value: 60, label: i18.t('shared:tfa.periods.oneHour') },
  { value: 1440, label: i18.t('shared:tfa.periods.oneDay') }
];
